import * as React from "react"
import TypeAhead, { TypeAheadElement } from "./TypeAhead";
import IDishCatalogueResponse, {IDishUnit} from "../models/maverick/IDishCatalogueResponse";
import * as _ from "lodash";
import SuggestionTagsContainer, { SuggestionItem } from "../containers/SuggestionTagsContainer";
import { IDietRecallFoodOptionValue } from "../models/IDietRecallMealItem";
import ModelFactory from "../models/ModelFactory";
import IStaticDataTASuggestions from "../models/staticData/IStaticDataTASuggestions";
import MealUnitComponent from "./MealUnitComponent";

export interface DishAdderProps {
    onDishAdd: (dish: IDietRecallFoodOptionValue) => void;
    fetchStaticDishes: (input: string) => Promise<IDishCatalogueResponse[]>;
    suggestions?: SuggestionItem[]; 
    mealSlot?: string;
}

export interface DishAdderState {
    dish: IDietRecallFoodOptionValue;
    availableUnits: IDishUnit[];
    isDishSelected: boolean;
}

class DishAdder extends React.Component<DishAdderProps, DishAdderState> {
    constructor(props: DishAdderProps) {
        super(props);
        this.state = {
            dish: ModelFactory.createNewDietRecallFoodOptionValue(),
            isDishSelected: false,
            availableUnits: []
        }
    }
    handleDishTypeAheadChange = (input: string) => {
        let dish = this.state.dish;
        dish.name = input;
        this.setState({dish});
        return this.props.fetchStaticDishes(input).then((dishes: IDishCatalogueResponse[]) => {
            let dishTypeAhead: TypeAheadElement[] = [];
            let reqIndex = dishes.map(item => item.name.toLowerCase()).indexOf(input.toLowerCase());
            if (input !== "") {
                if (_.isEmpty(dishes) || (!_.isEmpty(dishes) && reqIndex === -1)) {
                    let defaultTypeAheadElement = { value: null as any, label: input, isDefault: true };
                    dishTypeAhead.push(defaultTypeAheadElement);
                }
            }
            _.map(dishes, (dish: IDishCatalogueResponse) => {
                if (dish.approvalStatus === "APPROVED") {
                    let typeAheadElement: TypeAheadElement = {
                        value: dish.id,
                        label: dish.name,
                        others: {
                            units: dish.units
                        }
                    }
                    dishTypeAhead.push(typeAheadElement);
                }
            })

            if (reqIndex !== -1) {
                let requiredItem = dishTypeAhead[reqIndex];
                dishTypeAhead.splice(reqIndex, 1);
                dishTypeAhead.splice(0, reqIndex, requiredItem);
            }
            return Promise.resolve({options: dishTypeAhead, completed: true});
        }).catch((error: any) => {
            throw error;
        });
    }
    handleDishTypeAheadSelect = (elem: TypeAheadElement) => {
        let updatedDish = this.state.dish;
        updatedDish.id = elem && elem.value;
        updatedDish.name = elem && elem.label;
        this.setState({
            dish: updatedDish,
            isDishSelected: true,
            availableUnits: elem && elem.others && elem.others.units ? elem.others.units : []
        })
    }
    generateDishUnitItems = (): IStaticDataTASuggestions[] => {
        let dropdownItems: IStaticDataTASuggestions[] = [];
        _.map(this.state.availableUnits, (unit: IDishUnit) => {
            dropdownItems.push({
                displayValue: unit.unit,
                internalValue: unit.unit,
                suggestByDefault: true
            } as IStaticDataTASuggestions)
        })
        return dropdownItems;
    }
    onDishSizeChange = (elem: TypeAheadElement) => {
        if (elem) {
            let dish = this.state.dish;
            dish.unit = elem && elem.others.value.unit;
            dish.count = (elem && Number(elem.others.value.count)) || 0;
            this.setState({ dish })
        }
    }
    onDishSizeSelect = () => {
        this.props.onDishAdd(this.state.dish);
        this.setState({
            dish: ModelFactory.createNewDietRecallFoodOptionValue(),
            isDishSelected: false
        })
    }

    onSuggestionAdd = (item: SuggestionItem) => {
        const updatedMeals: any= {
            label: item.recommendation.displayName,
            value: item.recommendation.dishId,
            unit: item.recommendation.unit,
            count: item.recommendation.count
        };
        const dropdownItems: IDishUnit[] = [];
        this.props.fetchStaticDishes(updatedMeals.label).then((dishes: IDishCatalogueResponse[]) => {
            dishes.map((dishItem => {
                if(updatedMeals.label === dishItem.name){
                    let selectedDish = dishItem.units;
                    _.map(selectedDish, (unit: IDishUnit) => {
                        dropdownItems.push({
                            unit: unit.unit,
                            conversionToGrams: unit.conversionToGrams
                        })
                    })
                }
            }))
            updatedMeals.others = {};
            updatedMeals.others.units = dropdownItems;
            const typeAheadElement: TypeAheadElement = {
                others: updatedMeals.others,
                label: updatedMeals.label,
                value: updatedMeals.value
            }
            this.handleDishTypeAheadSelect(typeAheadElement);

        })
    }

    render() {
        let suggestions: SuggestionItem[] = this.props.suggestions;
        if (this.state.isDishSelected) {
            suggestions = !_.isEmpty(suggestions) && suggestions.filter((item: any) => this.state.dish.name != item.recommendation.displayName);
        }
        return (
            <div className={"dish-adder-container"}>
                {
                    !this.state.isDishSelected &&
                    <TypeAhead name={"dish-adder-input"} widgetName={"dish-adder"} value={this.state.dish.name} placeholder={"Start typing dish name"}
                               onTypeAheadChange={this.handleDishTypeAheadChange} onTypeAheadSelect={this.handleDishTypeAheadSelect} />
                }
                {
                    this.state.isDishSelected &&
                    <div className={"dish-unit-input-container"}>
                        <span>{this.state.dish.name}</span>
                        <MealUnitComponent 
                            unit={this.state.dish.unit}
                            count={this.state.dish.count}
                            dropdownItems={this.generateDishUnitItems()}
                            rootClass={"dish-adder"}
                            onDurationChange={this.onDishSizeChange}
                            onDishUnitSelect={this.onDishSizeSelect}
                        />
                    </div>
                }
                  {
                    !_.isEmpty(suggestions) &&
                    <SuggestionTagsContainer rootClass={"patient-diagnosis"} suggestions={suggestions} onTagSelect={this.onSuggestionAdd} />
                }
            </div>
        )
    }
}

export default DishAdder;